import React from 'react'
import Cards from '../components/cards'

const Feedback = () => {

    const cards = [
        {
            title: 'NAZ',
            details: 'NVCC-US Grade 12',
            body: "ANHS was extremely helpful during my college semester. Mr. Andra answered every question I had and also sent me exactly how he did it through Google classroom so I can have look back at it whenever I needed to study. As the semester went along, Mr. Andra and I became good friends because he is more than an excellent instructor, he's an amazing person. I recommend this service to everyone how is looking for an excellent tutor who is very knowledgeable and very helpful."
        },
        {
            title: 'Jacques S.',
            details: 'Rosaire Byblos - Grade 9',
            body: "Mr. Andre is a smart, funny&kind teacher.I started studying with him a month ago and until now everything he taught me is still screwed to my head and i cant even try to forget them.That's how much good he is at teaching.I suggest you guys who are seeking for knowledge to check him out.Thanks again for ANHS for helping me becoming the smart student i have always wanted to be."
        },
        {
            title: 'Mary Joe Ch.',
            details: 'Rosaire Byblos - Grade 9',
            body: 'Great teacher who uses great teaching methods. Helps you understand with the easiest and fastest ways. Works with you with patience and cares about his students.'
        },
        {
            title: 'Brian A.',
            details: 'Saint Joseph Jbeil - Grade 10',
            body: 'My experience with ANHS was very good. It made everything easier to learn while it saved time. Plus the fact that i could open and revise every session i had in a matter of seconds makes it better and better. Thank You!'
        },
        {
            title: 'Katia S.',
            details: 'ULB - 1st year Pharmacy',
            body: "j'adore les cours! Et la mise en page ! Cela facilite notre apprentissage et nous donne envie d'apprendre les maths! Tout est hyper bien organisé. Prof top bien expérimenté que je recommande!"
        },
        {
            title: 'Perla N.',
            details: 'Saint Joseph - Grade 12 LS',
            body: 'Very effective teaching methods, always teaching from the heart and making sure the student understands'
        },
        {
            title: 'Serena H.',
            details: 'Central College Jounieh - Grade 12 LS',
            body: 'A friend more than a teacher which makes things easier and more fun <3'
        },
        {
            title: 'Rebecca A.',
            details: 'College des Freres Maristes - Grade 9',
            body: "He's actually a hard working person who sacrifice all of his time to make us proud and made things so easy to understand"
        },
        // {
        //     title: 'Gabriella Moujaes',
        //     details: 'Rosaire Byblos Grade 12',
        //     body: 'From the very first day, your enthusiasm and ability to explain complex concepts in a simple and engaging manner have made every session enjoyable and productive. Your patience and willingness to go the extra mile to ensure I understand the material have benn invaluable. Not only you are an exceptional educator, but you also create a supportive and nurturing environment where i fell comfortable asking questions and seeking guidance. Your encouragement and belief in my abilites have boosted my confidence and motivated me to strive for excellence. Your commitment to my academic growth extends beyond the classroom. Your timely feedback, personalized study resources, and additional resources you recommend have benn instrumental in enhancing my understanding of the subject matter. I am truly grateful for your unwavering support and dedication to my success. Your Impact on my education will undoubtedly leave a lasting impression, and I am confident that the knowledge and skills I have gained under your guidance will serve me well in my future endeavors. Thank you once again for being an amazing tutor. Your passion, expertise, and genuine care for your students make you truly exceptional. I am fortunate to have you as my tutor, and I look forward to continuing this incredible learning journey with.'
        // }

    ]

    return (
        <div className='w-full lg:py-10 py-3 bg-gray-300 lg:px-32 px-5' id='feedback'>
            <div className='flex flex-col text-center lg:gap-10 gap-8'>
                <h1 className='font-semibold text-4xl text-black'>Feedback</h1>
                <h2 className='text-2xl font-semibold'>Some feedbacks of our lovely students</h2>
                <div className='flex lg:flex-row flex-col gap-5 justify-center text-center items-center w-full h-full'>
                    <Cards cards={cards} />
                </div>
            </div>
        </div>
    )
}

export default Feedback